import React, { Component } from 'react';
import { MODAL_HIDDEN_COLUMNS } from '../../util/enums/EnumModals';
import ModalLoading from './ModalLoading';

class ModalHiddenColumns extends Component {
  static modalType() {
    return MODAL_HIDDEN_COLUMNS;
  }

  static reducer(modals) {
    return modals.hiddenColumnsModal;
  }

  static title() {
    return (
      <span>
        <span
          className="glyphicon glyphicon-ban-circle margin-right-10"
          aria-hidden="true"
        />
        Hide tables / columns
      </span>
    );
  }

  static subTitle() {
    return (
      <span>
        Hide unnecessary or sensitive tables and / or columns. Please note that
        hiding primary and foreign id columns is <b>not recommended</b> as they
        are needed for joins.
      </span>
    );
  }

  render() {
    const { state, userInteraction } = this.props;

    if (state.saving) {
      return (
        <span>
          <ModalLoading /> Saving...
        </span>
      );
    }

    const schemas = [];
    const buildTreeNode = (children, schema, tbl, column) => {
      const title = column || tbl || schema;
      const toggleHidden = () => {
        userInteraction({
          section: 'toggle-hidden',
          schema,
          table: tbl,
          column,
        })(/* NOTE: we don't preventDefault here, as otherwise the checkbox gets out of sync */);
      };
      const toggleExpanded = (e) => {
        userInteraction({
          section: 'toggle-expanded',
          schema,
          table: tbl,
          column,
        })(e);
      };
      const showAll = (e) => {
        userInteraction({
          section: 'show-all',
          schema,
          table: tbl,
          column,
        })(e);
      };
      const hideAll = (e) => {
        userInteraction({
          section: 'hide-all',
          schema,
          table: tbl,
          column,
        })(e);
      };
      let isChecked = false;
      if (column) {
        isChecked = state.nodes[schema].nodes[tbl].nodes[column].hidden;
      } else if (tbl) {
        isChecked = state.nodes[schema].nodes[tbl].hidden;
      } else {
        isChecked = state.nodes[schema].hidden;
      }
      return (
        <span>
          {isChecked ? (
            <span className="faint hidden-node strike-through">{title}</span>
          ) : (
            <a className="hidden-node" onClick={toggleExpanded} href="#">
              {title}
            </a>
          )}
          &nbsp;
          <span className="checkbox-hide">
            <label className="faint">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={toggleHidden}
              />{' '}
              hide
            </label>
          </span>
          {!children || isChecked || children.length === 0 ? null : (
            <div className="child-nodes">
              <div className="hidden-all">
                <a
                  onClick={hideAll}
                  className="btn btn-outline-dark btn-xs"
                  href="#"
                >
                  hide all
                </a>{' '}
                <a
                  onClick={showAll}
                  className="btn btn-outline-dark btn-xs"
                  href="#"
                >
                  show all
                </a>
              </div>
              <ul>{children}</ul>
            </div>
          )}
        </span>
      );
    };
    Object.keys(state.nodes).forEach((schema, index) => {
      const tables = [];
      if (state.nodes[schema].expanded) {
        Object.keys(state.nodes[schema].nodes).forEach((table, _index) => {
          const columns = [];
          if (state.nodes[schema].nodes[table].expanded) {
            Object.keys(state.nodes[schema].nodes[table].nodes).forEach(
              (column, __index) => {
                columns.push(
                  <li key={__index}>
                    {buildTreeNode(null, schema, table, column)}
                  </li>,
                );
              },
            );
          }
          tables.push(
            <li key={_index}>{buildTreeNode(columns, schema, table)}</li>,
          );
        });
      }
      schemas.push(<li key={index}>{buildTreeNode(tables, schema)}</li>);
    });

    return (
      <div className="hidden-columns-modal">
        <div className="margin-left-20">
          <p>
            Click a table to view its columns. Click 'hide' to hide a table or
            column.
          </p>
        </div>
        <ul>{schemas}</ul>
        <div className="margin-left-20">
          <p>
            Note: hiding tables does not prevent them from being accessed via
            Trevor's SQL editor.
          </p>
          <label className="padding-5 font-weight-normal">
            <input
              type="checkbox"
              checked={state.hideSQLEditor}
              onChange={() =>
                userInteraction({ section: 'toggle-sql-editor' })()
              }
            />{' '}
            Hide SQL editor from Collaborators
          </label>
        </div>
      </div>
    );
  }
}

export default ModalHiddenColumns;
